export enum DeviceOs {
	Windows = 0,
	Linux = 10,
	MacOs = 20,
	iOS = 30,
	iPadOS = 40,
	Android = 50
}